import { render, staticRenderFns } from "./error-modal.vue?vue&type=template&id=61e6f89e"
import script from "./error-modal.ts?vue&type=script&lang=ts&external"
export * from "./error-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./error-modal.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports